<template>
    <!--成绩单-->
  <div id="scorelistbs">
    <div class="title">
      <div>用户名称</div>
      <div>综合素质</div>
      <div>教育知识</div>
    </div>
    <vue-seamless-scroll :data="listData" :class-option="classOption" class="seamless-warp">
      <ul class="item">
        <li v-for="(item, index) in listData" :key="index">
          <div v-text="item.name"></div><div v-text="item.subject"></div><div v-text="item.score"></div>
        </li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
export default {
  name: 'scoreListBs',
  data () {
    return {
      listData: [{
        'name': '李**',
        'subject': '85',
        'score': '81'
      }, {
        'name': '徐**',
        'subject': '79',
        'score': '98'
      }, {
        'name': '杨**',
        'subject': '84',
        'score': '88'
      }, {
        'name': '唐**',
        'subject': '91',
        'score': '89'
      }, {
        'name': '孙**',
        'subject': '76',
        'score': '92'
      }, {
        'name': '徐**',
        'subject': '97',
        'score': '88'
      }, {
        'name': '杨**',
        'subject': '83',
        'score': '86'
      }, {
        'name': '唐**',
        'subject': '93',
        'score': '96'
      }, {
        'name': '田**',
        'subject': '88',
        'score': '95'
      }]
    }
  },
  computed: {
    classOption () {
      return {
        direction: 1,
        step: 0.5
      }
    }
  }
}
</script>

<style scoped lang="stylus">
  .seamless-warp {
    height: 229px;
    overflow: hidden;
  }
  #scorelistbs
    background: #fff
    .title
      display: flex
      justify-content: space-between
      align-items: center
      & > div
        width: 1.5rem
        height: 1rem
        line-height: 1rem
        font-size: .32rem
        color: #333
        font-weight: 700
        text-align: center
    ul
      li
        display: flex
        justify-content: space-between
        align-items: center
        height: .59rem
        border-top: .02rem solid #F3F4F5
        & > div
          width: 1.5rem
          height: .59rem
          line-height: .59rem
          font-size: .3rem
          color: #333
          text-align: center
          &.red
            color: #FF7052
</style>



// WEBPACK FOOTER //
// src/components/share/plug/scoreListBs.vue